// @ts-nocheck -- staged migration: add explicit types before removing this directive.
import { hiraganas } from "./hiraganaList";
import { katakana } from "./katakana";

// Punctuation and marks that appear in the keyboard's kana lists but aren't
// actual kana characters, so they're excluded from writing practice.
const EXCLUDED_SYMBOLS = new Set([" ", "、", "。", "？", "！", "ー", "・", "ヰ", "ヱ", "ヴ"]);

function isWritableKana(item) {
    return (
        item.symbol.length === 1 &&
        !EXCLUDED_SYMBOLS.has(item.symbol) &&
        // Small kana (っ ゃ ゅ ょ, katakana's small vowels, etc.) only appear
        // as part of combination characters in normal writing, so they're
        // excluded as standalone practice entries.
        !item.romaji.startsWith("small-")
    );
}

export const hiraganaWritingList = hiraganas.filter(isWritableKana);
export const katakanaWritingList = katakana.filter(isWritableKana);
